<template>
  <OpportunitiesFeed v-bind="{ getFirstPage, getNextPage }" />
</template>

<script setup lang="ts">
import { groqFeed } from "~/groq/feed"

const { getFirstPage, getNextPage } = groqFeed("opportunities")
</script>
